import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';

const sizeMixin = (size: number) => css`
  & > svg {
    ${size &&
    css`
      width: ${rem(size)};
      height: auto;
    `}
  }
`;

export const StyledIconButton = styled.button<{ $size: number }>`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  border-radius: ${rem(2)};

  &:focus-visible {
    outline: ${rem(2)} solid ${variables.colors.highlight};
    outline-offset: ${rem(2)};
  }

  ${(props) => sizeMixin(props.$size)}
`;

export const StyledIconSpan = styled.span<{ $size: number }>`
  display: inline-flex;

  ${(props) => sizeMixin(props.$size)}
`;
